<ul class="controparti m0">
	<li class="panel" *ngFor="let option of optionsList; let indice = index">
		<div class="controparte">
			<div>
				<a data-toggle="collapse" aria-expanded="true" (click)="openDetail(option, indice)"
					[attr.aria-controls]="'subcontroparteModalAdd' + indice" data-parent="#controparticollapse"
					class="{{activeIndex === indice ? 'accordion-collapse' : 'accordion-collapsed'}} mt-toggle"><span>Apri</span></a>
				<p class="col-sm-3 button-associa">
					<button class="btn btn-danger associa disassocia" [disabled] = "option.controparte.primario && optionsList.length > 1" (click)="disassocia(option, indice)">{{labelButton}}</button>
				</p>
				<p class="titolo col-sm-3 mt-5"
					*ngIf="option.controparte.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
						{{option.controparte.parte.cognome}} {{option.controparte.parte.nome}}
				</p>
				<p class="titolo col-sm-3 mt-5"
					*ngIf="option.controparte.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
						{{option.controparte.parte.ragioneSociale}}
				</p>
				<p class="col-sm-3 matricola mt-5"
					*ngIf="option.controparte.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
					C/F: <strong>{{option.controparte.parte.codiceFiscale}}</strong>
				</p>
				<p class="col-sm-3 matricola mt-5"
					*ngIf="option.controparte.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
					P.IVA: <strong>{{option.controparte.parte.partitaIva}}</strong>
				</p>
				<p class="col-sm-3 matricola mt-5" *ngIf="!option.controparte.parte.id || option.controparte.parte.id.startsWith('TEMP')">
					<span class="label label-success">Nuova anagrafica</span>
				</p>

 
				<div class="data_opzioni col-sm-2  mt-5">
					<ul>
						<ng-template [ngIf]="option.controparte.primario">
							<li class="star primario"></li>
						</ng-template>
					
					</ul>
				</div>
<!-- 
				<p class="col-sm-1 mt-5" *ngIf="option.controparte.primario">
					<li class="star"></li>
				</p> -->

			</div>
		</div>
		<ul class="{{activeIndex === indice ? 'collapsed' : 'collapse'}} subcontroparte">

			<li>
				<div class="container_dati_generali">
					<div class="container_tab_nav">
						<ul class="nav nav-tabs two">
							<li [style.width.%]="50" class="{{currentTab === 'ASSOCIATIVA' ? 'active' : 'inactive'}}"><a
									data-toggle="tab" (click)="currentTab = 'ASSOCIATIVA'"
									aria-expanded="true">Associativa</a></li>
							<li [style.width.%]="50" class="{{currentTab === 'ANAGRAFICA' ? 'active' : 'inactive'}}"><a
									data-toggle="tab" (click)="currentTab = 'ANAGRAFICA'"
									aria-expanded="false">Anagrafica</a></li>
						</ul>
						<div class="tab-content">
							<div *ngIf="currentTab === 'ASSOCIATIVA'" class="tab-pane fade active in">
								<div class="row">
									<div *ngIf="editing" class="col-12">
										<app-associazione-controparte-form [primariaPreselected] = "optionsList.length === 1 || (optionsList.length  > 1 && option.controparte.primario)" [controparte]="option.controparte"
											[parte]="option.controparte.parte" [position]="indice"
											(onReturn)="retrieveControparte($event)"></app-associazione-controparte-form>
									</div>
									<div *ngIf="!editing" class="col-12">
										<app-associativa-controparti [controparte]="option.controparte">
										</app-associativa-controparti>
									</div>
								</div>
								<div class="row" *ngIf="!editing">
									<p class="col-sm-3 col-sm-offset-9 col-xs-3 col-xs-offset-9">
										<button type="button" class="btn btn-primary btn-block"
											(click)="editing = true">Modifica
											dati</button>
									</p>
								</div>
							</div>
							<div *ngIf="currentTab === 'ANAGRAFICA'" class="tab-pane fade active in">
								<app-dati-generali-anagrafiche-search
									[option]="{hasDetailsAnagrafica:false ,anagrafica:option.controparte.parte}"
									[isLegale]="isLegale" [isPartiSearch]="isPartiSearch"
									[isControparte]="isControparte"></app-dati-generali-anagrafiche-search>
							</div>
						</div>
					</div>

				</div>
			</li>

		</ul>
	</li>
</ul>